var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 133,
    viewBox: "0 0 130 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 130C100.899 130 130 100.899 130 65C130 29.1015 100.899 0 65 0C29.1015 0 0 29.1015 0 65C0 100.899 29.1015 130 65 130Z",
    fill: "#EAECF0"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4741_30985)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4741_30985",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 130,
    height: 130
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 130C100.899 130 130 100.899 130 65C130 29.1015 100.899 0 65 0C29.1015 0 0 29.1015 0 65C0 100.899 29.1015 130 65 130Z",
    fill: "url(#paint0_linear_4741_30985)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4741_30985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.267 37.2656H27.7337C25.3405 37.2656 23.4004 39.2057 23.4004 41.599V132.599C23.4004 134.992 25.3405 136.932 27.7337 136.932H102.267C104.66 136.932 106.6 134.992 106.6 132.599V41.599C106.6 39.2057 104.66 37.2656 102.267 37.2656Z",
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1997 45.9297H34.6664C33.2305 45.9297 32.0664 47.0937 32.0664 48.5297C32.0664 49.9656 33.2305 51.1297 34.6664 51.1297H57.1997C58.6357 51.1297 59.7997 49.9656 59.7997 48.5297C59.7997 47.0937 58.6357 45.9297 57.1997 45.9297Z",
    fill: "#EAECF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1997 82.3359H34.6664C33.2305 82.3359 32.0664 83.5 32.0664 84.9359C32.0664 86.3719 33.2305 87.5359 34.6664 87.5359H57.1997C58.6357 87.5359 59.7997 86.3719 59.7997 84.9359C59.7997 83.5 58.6357 82.3359 57.1997 82.3359Z",
    fill: "#EAECF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6003 58.9297H36.4003C34.4857 58.9297 32.9336 60.4818 32.9336 62.3964V71.063C32.9336 72.9776 34.4857 74.5297 36.4003 74.5297H93.6003C95.5149 74.5297 97.0669 72.9776 97.0669 71.063V62.3964C97.0669 60.4818 95.5149 58.9297 93.6003 58.9297Z",
    stroke: "#98A2B3",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5997 94.4688H36.3997C34.0065 94.4688 32.0664 96.4088 32.0664 98.8021V105.735C32.0664 108.129 34.0065 110.069 36.3997 110.069H93.5997C95.993 110.069 97.9331 108.129 97.9331 105.735V98.8021C97.9331 96.4088 95.993 94.4688 93.5997 94.4688Z",
    fill: "#EAECF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9335 27.7302C47.8481 27.7302 49.4001 26.1781 49.4001 24.2635C49.4001 22.349 47.8481 20.7969 45.9335 20.7969C44.0189 20.7969 42.4668 22.349 42.4668 24.2635C42.4668 26.1781 44.0189 27.7302 45.9335 27.7302Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9999 27.7302C66.9145 27.7302 68.4665 26.1781 68.4665 24.2635C68.4665 22.349 66.9145 20.7969 64.9999 20.7969C63.0853 20.7969 61.5332 22.349 61.5332 24.2635C61.5332 26.1781 63.0853 27.7302 64.9999 27.7302Z",
    fill: "#98A2B3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0682 27.7302C85.9828 27.7302 87.5349 26.1781 87.5349 24.2635C87.5349 22.349 85.9828 20.7969 84.0682 20.7969C82.1536 20.7969 80.6016 22.349 80.6016 24.2635C80.6016 26.1781 82.1536 27.7302 84.0682 27.7302Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4741_30985",
    x: 17.4004,
    y: 28.2656,
    width: 95.1992,
    height: 104.734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4741_30985"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4741_30985",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4741_30985",
    x1: 65,
    y1: 0,
    x2: 65,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/NoData.65d1d0e7394040cb4b460010488b1d8e.svg";
export { ForwardRef as ReactComponent };